import { MilkmanApi } from '../api/MilkmanApi'

import { shipmentZonesStore } from '../store/shipmentZonesStore'
import { subscriptionStore } from '../store/subscriptionStore'
import { deliveryStore } from '../store/deliveryStore'
import { orderStore } from '../store/orderStore'
import { menuStore } from '../store/menuStore'

const moment = require('moment')

export const milkmanStore = {
	api: MilkmanApi, 
	sendAddress: false,
	state: {
    	hoursObj: null,
    	timeRanges: true,
    	loaded: null
	},

	config: {
		hourParcelIsReady: '17:45'
	},

	callMilkman (shipment, delivery, state, zipCode, city, street, latitude, longitude) {
		/* if (!menuStore.state.menu) {
			return Promise.resolve(1)
		} */
		
    if (!state) {
      state = this.state
    }

    if (!city) {
      city = subscriptionStore.state.subscriptionParams.city
    }

    if (!zipCode) {
      zipCode = subscriptionStore.state.subscriptionParams.zip_code
    }

		if (!street) {
      street = subscriptionStore.state.subscriptionParams.street
    }

		if (!latitude) {
      latitude = subscriptionStore.state.subscriptionParams.latitude
    }

		if (!longitude) {
      longitude = subscriptionStore.state.subscriptionParams.longitude
    }

		/* var weekStart = menuStore.state.menu.date.start */
		var shipmentDay = subscriptionStore.state.shipment_day

		// calculate shipment date 
		var shipmentDayDate = moment(shipment).format('YYYY-MM-DD')
		var deliveryDayDate = moment(delivery).format('YYYY-MM-DD')
		state.hoursObj = [];
		var api = new this.api()
		var params = {
			firstAvailability: shipmentDayDate + 'T' + this.config.hourParcelIsReady,
			city: city,
			postalCode: zipCode,
		}

		if(this.sendAddress) {
			params.addresses = [
				{
					address: street,
					lat: latitude,
					lon: longitude
				}
			]

			if(latitude == null) return Promise.reject()
		}

		return api.get({ params: params })

		.then(response => {
			
			var pricesArray = response.body.result.prices.find(r => r[0] === deliveryDayDate)


			if (pricesArray) {

				state.hoursObj = pricesArray[1]

				for (var x in pricesArray[1]) {

					var price = pricesArray[1][x]

					state.timeRanges = Object.values(price).filter(val => val !== null).length > 0

					if (state.timeRanges) {
						break;
					}
				}

				state.loaded = true;

			} else {
				state.timeRanges = false
				state.hoursObj = []
				state.loaded = false;
			}
			return response
		})

		.catch(response => {
			if(response && response.status == 0 && response.ok == false) {
				throw 'MILKMAN_API_INTERNAL_ERROR'
			}
			// sesion id??
			state.timeRanges = false
		})
	}
}